<div [class]="renderClass()" [hidden]="hideThis">
    <ng-container *ngFor="let fld of fieldDataCols.Columns">
        <app-form-field [formFieldObj]="fld" [index] = "fld.ItemIndex" [fieldVisible]="hideThis" class="col-sm-{{fld.LayoutCols}} "></app-form-field>
    </ng-container>
</div>
